import { render, staticRenderFns } from "./TransferRecord.vue?vue&type=template&id=4d2c3ac6&scoped=true"
import script from "./TransferRecord.vue?vue&type=script&lang=js"
export * from "./TransferRecord.vue?vue&type=script&lang=js"
import style0 from "./TransferRecord.vue?vue&type=style&index=0&id=4d2c3ac6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c3ac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2c3ac6')) {
      api.createRecord('4d2c3ac6', component.options)
    } else {
      api.reload('4d2c3ac6', component.options)
    }
    module.hot.accept("./TransferRecord.vue?vue&type=template&id=4d2c3ac6&scoped=true", function () {
      api.rerender('4d2c3ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/Balance/TransferRecord.vue"
export default component.exports